import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { discountMobx } from 'restaurant'
import { Icon } from '@cps'
import './index.scss'

interface IProps {
  show: boolean;
  addBottom?: number;
}

const DiscountOrderSwapBuyTip: FC<IProps> = ({ show, addBottom = 0 }) => {
  const { orderSwapBuyActivity } = discountMobx

  // 没有整单换购活动 || 不展示
  if (!show || !orderSwapBuyActivity) return null

  return (
    <div className='discount-order-swap-buy-tip-wrapper' style={{ bottom: 80 + addBottom }}>
      {i18n.t('checkout.orderSwapBuy.selectTip')}
      <Icon name='jiantou' size={18} />
    </div>
  )
}

export default observer(DiscountOrderSwapBuyTip)
